import { render, staticRenderFns } from "./zen_why_a_charge.vue?vue&type=template&id=f670aa44&scoped=true&"
import script from "./zen_why_a_charge.vue?vue&type=script&lang=js&"
export * from "./zen_why_a_charge.vue?vue&type=script&lang=js&"
import style0 from "./zen_why_a_charge.vue?vue&type=style&index=0&id=f670aa44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f670aa44",
  null
  
)

export default component.exports